import calculHeightHeader from "./calculHeightHeader";
import illustrationHeight from "./illustrationHeight";


const menuSticky = () => {
	const header = document.querySelector('.fixed-header');
	const navBar = document.getElementById('header');


	if (navBar) {

		let navPosition = navBar.offsetTop + illustrationHeight();

		// apply initial height
		let headerHeight = calculHeightHeader();
		header.style.height = headerHeight[1] + 'px';

		window.addEventListener('scroll', function () {
			if (window.scrollY > navPosition) {
				header.classList.add('sticky');
			} else {
				header.classList.remove('sticky');
			}
		});
	}
}

export default menuSticky;
